/**
 * CustomerOrdersPage — a customer's Orders tab, `/customers/:customerId/orders`:
 * the orders list fixed to one customer, inside the customer's frame.
 * Tharstern jobs are on the Jobs tab; All history shows both systems in one
 * list. The customer's id is its account code, which the list filters on.
 */
import { useCustomerRouteId } from "../app/components/domain/customers/useCustomerRouteId";
import { CustomerFrame } from "../app/components/domain/customers/CustomerFrame";
import { CustomerOrdersViewSwitch } from "../app/components/domain/orders/CustomerOrdersViewSwitch";
import { OrdersList } from "../app/components/domain/orders/OrdersList";

export function CustomerOrdersPage() {
  const customerId = useCustomerRouteId();
  if (customerId === null) return null;
  return (
    <CustomerFrame customerId={customerId} current="orders">
      <div className="space-y-3">
        <CustomerOrdersViewSwitch customerId={customerId} current="orders" />
        <OrdersList customerCode={customerId} />
      </div>
    </CustomerFrame>
  );
}
